import http from './api';
import authHeader from './auth-header';

class BidderService {
 
  getInterestForm(id) {
    return http.get(`interested/${id}`);
  }
  createBidder(id, data) {
    return http.post(`interested/${id}`, data);
  }
  getMyAuctions() {
    return http.get('bidder/myAuctions', { headers: authHeader() });
  }
  PlaceBid(data) {
    return http.post('bidder/myAuctions', data,{ headers: authHeader() });
  }
  disableProxyBidding(id){
    return http.post(`bidder/disableProxyBid/${id}`, null,{ headers: authHeader() });
  }
  enableProxyBidding(id, data){
    return http.post(`bidder/enableProxyBid/${id}`, data, { headers: authHeader() });
  }
  getBidderInterest(id,uuid) {
    return http.get(`interested_update/${id}/${uuid}`);
  }

  updateBidderInterest(id,uuid,data) {
    return http.post(`interested_update/${id}/${uuid}`,data);
  }
}

export default new BidderService();
